<template>
  <div>
    <v-form ref="consent" lazy-validation>
      <v-layout>
        <v-checkbox
          v-model="yesValue"
          class="shrink mr-2"
          :data-testid="testId + '-yes'"
          label="Yes"
          style="grid-area: statusYes"
        />
        <v-checkbox
          v-model="noValue"
          class="shrink mr-2"
          :data-testid="testId + '-no'"
          label="No"
          style="grid-area: statusNo"
        />
        <template style="grid-area: statusContent">
          <div>
            <slot ref="content"></slot>
          </div>
        </template>
      </v-layout>
    </v-form>
  </div>
</template>

<script>
export default {
  props: {
    testId: String,
  },

  data: () => ({
    consentAck: false,
    yesValue: false,
    noValue: false,
    status: null,
  }),
  watch: {
    noValue: function() {
      if (this.noValue) {
        this.status = false;
        this.yesValue = false;
      }
      if (this.yesValue === this.noValue) {
        this.status = null;
      }
      this.$emit("updateAck", this.status, this.testId);
    },
    yesValue: function() {
      if (this.yesValue) {
        this.status = true;
        this.noValue = false;
      }
      if (this.yesValue === this.noValue) {
        this.status = null;
      }
      this.$emit("updateAck", this.status, this.testId);
    },
  },
};
</script>

<style scoped>
/* #yes-no-grid {
  display: grid;
  grid-gap: 10px;
  grid-template-areas: "statusYes statusNo statusContent";
  text-align: left;
} */
</style>
